import * as types from '../constants/actionTypes';
import { setToken, getToken } from '../utils/tokenUtil';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.

const initialState = {
  isAuthenticated: false,
  member: null,
  passwordReset: false,
  token: ""
}

const auth = (state = initialState, action) => {
  {
  switch (action.type) {

    case types.LOGIN_REQUEST:
      return Object.assign({}, state, {
        isAuthenticated: false,
        user: action.creds
      })
    case types.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticated: true,
        isRegistered: true,
        token: action.token
      })
    case types.LOGIN_FAILURE:
      return Object.assign({}, state, {
        isAuthenticated: false,
        errorMessage: action.message
      })
    case types.LOGOUT_REQUEST:
      return Object.assign({}, state, {
        isAuthenticated: false,
        member: null
      })
    case types.LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticated: false
      })

      case types.RECEIVE_PROFILE:
        return Object.assign({}, state, {
            member: action.profile,
            isAuthenticated: true
        });
      break;


      
    case types.IDENTITY_REQUEST:
      return Object.assign({}, state, {
        lastName: action.creds.lastname,
        last4SSN: action.creds.last4,
        dobMonth: action.creds.month,
        dobDay: action.creds.day,
        dobYear: action.creds.year
      })
    case types.IDENTITY_SUCCESS:
      return Object.assign({}, state, {
        errorMessage: '',
        MPI: action.MPI,
        isIdentified: true
      })
    case types.IDENTITY_ERROR:
      return Object.assign({}, state, {
        errorMessage: action.message
      })
    case types.PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isAuthenticated: false,
        user: action.creds
      })
    case types.PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        errorMessage: '',
        successMessage: "Your password has been updated.",
        isRegistered: true,
        passwordReset: true,
        isIdentified: true
      })
    case types.PASSWORD_COMPLETE:
      return Object.assign({}, state, {
        passwordReset: action.passwordReset
      })
    case types.PASSWORD_ERROR:
      return Object.assign({}, state, {
        errorMessage: action.message
      });
      break;
      
    case types.REGISTER_REQUEST:
    case types.SAVE_REG_STATE:
      return Object.assign({}, state, {
        email: action.creds.email,
        emailConfirm: action.creds.emailConfirm,
        password: action.creds.password,
        passwordConfirm: action.creds.passwordConfirm,
        agreedToTerms: action.creds.agreedToTerms
      });
      break;

    case types.REGISTER_SUCCESS:
      return Object.assign({}, state, {
        errorMessage: '',
        isRegistered: true
      })
    case types.REGISTER_ERROR:
      return Object.assign({}, state, {
        errorMessage: action.message
      })

  
      
    case types.CLEAR_REG_STATE:
      return Object.assign({}, state, {
        isRegistered: false,
        isIdentified: false,
        errorMessage: "",
        email: "",
        emailConfirm: "",
        password: "",
        passwordConfirm: "", 
        agreedToTerms: false,
        token: ""
      });
      break;

      


    // case types.RECEIVE_INSURANCE_CARD:
    //   return Object.assign({}, state, {
    //     insuranceCards: action.cards
    //   })

    case types.RECEIVE_BENEFITS:
      return Object.assign({}, state, {
        benefits: action.benefits
      })

    case types.RECEIVE_INCENTIVES:
      return Object.assign({}, state, {
        incentives: action.incentives
      })

      
    case types.ACCOUNT_VERIFIED:
      return Object.assign({}, state, {
        isVerified: action.verified
      })

          
    default:
      return state
    }
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/auth.js